import React, { ReactElement } from 'react';
import { CarouselCard } from '@fluentui/react-carousel-preview';
import { ModalBottomButtonContainer } from '../modals/Styles';
import { PrimaryButton, SecondaryButton } from '../connectedForm/Button';
import styled from 'styled-components';

const DocumentCard = styled.div`
  min-height: 300px;
  height: 100%;
  position: relative;
  padding-bottom: 30px;
  max-width: 800px;
`;

export const DocumentCarouselItem = ({
  children,
  ['data-testid']: dataTestId,
}: {
  children: ReactElement;
  'data-testid': string;
}) => {
  return (
    <CarouselCard>
      <DocumentCard data-testid={dataTestId}>{children}</DocumentCard>
    </CarouselCard>
  );
};
